<template>
    <div class="fullname safe-distance-top">
        <div class="fullname_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">姓名</div>
            <div class="determine" @click="setSave">确定</div>
        </div>
        <div class="fullname_bottm">
            <van-cell-group style="border-radius: 8px">
                <van-field
                    v-model="realname"
                    placeholder="请输入用户名"
                    maxlength="10"
                    :disabled="disabled"
                >
                    <template #button>
                        <van-button size="small" style="border: none"
                            >{{ realname.length }}/10</van-button
                        >
                    </template></van-field
                >
            </van-cell-group>
        </div>
        <div class="prompt">请填写真实姓名，认证通过后无法修改</div>
    </div>
</template>

<script>
export default {
    name: "fullname",
    data() {
        return {
            realname: "",
            scholar: "",
            nickname: "",
            disabled: false,
            // 姓名
            obj: {},
        };
    },
    mounted() {
        // 已认证完成
        if (sessionStorage.getItem("scholarUserInfo")) {
            let obj = JSON.parse(sessionStorage.getItem("scholarUserInfo"));
            let key = this.$route.query.realname.split(".");
            console.log(key);
            this.realname = obj[key[0]][key[1]];
            this.disabled = true;
        } else {
            this.disabled = false;
        }
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        setSave() {
            if (!sessionStorage.getItem("scholarUserInfo")) {
                this.obj = JSON.parse(sessionStorage.getItem("subInfo"));
                this.obj.userInfo.realname = this.realname;
                sessionStorage.setItem("subInfo", JSON.stringify(this.obj));
                window.history.go(-1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.fullname {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .fullname_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .fullname_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }
}
</style>
